// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Lp_6","loaderOuter":"PageOverlayLoader_loaderOuter__1PIUz"};